export interface Treatment {
  id: string;
  title: string;
  slug: string;
  description: string;
  treatmentTime: string;
  successRate: string;
  heroImage: string;
  width?: number;
  height?: number;
}

export const treatments: Treatment[] = [
  {
    id: 'dentalImplants',
    title: 'Dental Implants',
    slug: 'dental-implants',
    description: 'Permanent tooth replacement solution that looks and functions like natural teeth.',
    treatmentTime: '2-3 hours',
    successRate: '98%',
    heroImage: '/images/treatments/Dental-Implants.webp', width: 800, height: 600
  },
  {
    id: 'teethWhitening',
    title: 'Teeth Whitening',
    slug: 'teeth-whitening',
    description: 'Professional teeth whitening for a brighter, more confident smile.',
    treatmentTime: '1-2 hours',
    successRate: '95%',
    heroImage: '/images/treatments/teeth-whitening.webp', width: 1024, height: 683
  },
  {
    id: 'dentalVeneers',
    title: 'Dental Veneers',
    slug: 'dental-veneers',
    description: 'Custom-made shells that cover the front surface of teeth to improve appearance.',
    treatmentTime: '2-3 visits',
    successRate: '97%',
    heroImage: '/images/treatments/dental-veneers.webp', width: 3360, height: 2240
  },
  {
    id: 'hollywoodSmile',
    title: 'Hollywood Smile',
    slug: 'hollywood-smile',
    description: 'Complete smile makeover for the perfect Hollywood look.',
    treatmentTime: '2-3 weeks',
    successRate: '99%',
    heroImage: '/images/treatments/hollywood-smile.webp', width: 1000, height: 667
  },
  {
    id: 'allOnFour',
    title: 'All-on-4 Implants',
    slug: 'all-on-four',
    description: 'Full arch rehabilitation with just four dental implants.',
    treatmentTime: '4-6 hours',
    successRate: '96%',
    heroImage: '/images/treatments/All-on-4+Implants.webp', width: 1200, height: 675
  },
  {
    id: 'rootCanal',
    title: 'Root Canal Treatment',
    slug: 'root-canal',
    description: 'Treatment to repair and save severely damaged or infected teeth.',
    treatmentTime: '1-2 hours',
    successRate: '95%',
    heroImage: '/images/treatments/root-canal.webp', width: 1200, height: 800
  }
];
